export default __webpack_public_path__ + "5884dd614d0832518487ef15b9dec4dc.woff2";